import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuturesService } from './futures.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [FuturesService],
})
export class FuturesCoreModule {}
